export function setWeather (state, weather) {
    state.weather = weather;
  }

  export function weatherError(state, payload){
    state.error = true
    state.errorMessage = payload
    state.weather = []
  }
  